var BpiStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import _ from "underscore";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { SearchApplicantAgentComponent } from "../../../tabs/applications/application-search/search-applicant-agent/search-applicant-agent.component";
import { SearchAssignedToComponent } from "../../../tabs/applications/application-search/search-assigned-to/search-assigned-to.component";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject, throwError } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { SearchCreatedDateComponent } from "../../../tabs/applications/application-search/search-created-date/search-created-date.component";
import { SearchApplicantInfoComponent } from "../../../tabs/applications/application-search/search-applicant-info/search-applicant-info.component";
import { Router } from "@angular/router";
import { SearchStatusComponent } from "../../../tabs/applications/application-search/search-status/search-status.component";
import { RecipientSelectService } from "../../components/recipient-select/shared/service/recipient-select.service";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { SearchOwnerInfoComponent } from "../../../tabs/applications/application-search/search-owner-info/search-owner-info.component";
import { SearchPropertyInfoBpiComponent } from "../../../tabs/applications/application-search/modules/bpi/search-property-info-bpi/search-property-info-bpi.component";
import { ObjectUtils } from "../../utils/object-utils";
import RecipientUtils from "../../utils/recipient-utils";
import { EsriDataTypeEnum } from "../../models/esri-data-type-enum";
import { SearchStartDateComponent } from "../../../tabs/applications/application-search/search-start-date/search-start-date.component";
import { SearchCategoryComponent } from "../../../tabs/applications/application-search/search-category/search-category.component";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { SearchBuildingUseComponent } from "../../../tabs/applications/application-search/search-building-use/search-building-use.component";
import { ApiBuildingPlansInspectorateConstants } from "../../constants/api-constants/api-building-plans-inspectorate.constants";
import { CreateApplicationDetailsBpiComponent } from "../../../application/create-application/modules/bpi/create-application-details-bpi/create-application-details-bpi.component";
import { CreateApplicationLocationBpiComponent } from "../../../application/create-application/modules/bpi/create-application-location-bpi/create-application-location-bpi.component";
import { ViewApplicationDetailsBpiComponent } from "../../../application/view-application/modules/bpi/view-application-details-bpi/view-application-details-bpi.component";
import { ViewApplicationLocationBpiComponent } from "../../../application/view-application/modules/bpi/view-application-location-bpi/view-application-location-bpi.component";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { ViewApplicationBpamsApplicationsBpiComponent } from "../../../application/view-application/modules/bpi/view-application-bpams-applications-bpi/view-application-bpams-applications-bpi.component";
import { ModulePrefix } from "../../models/module-prefix.model";
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var BpiSearchOptions;
(function (BpiSearchOptions) {
    BpiSearchOptions["ReferenceNumber"] = "Reference Number";
    BpiSearchOptions["MyApplications"] = "My Applications";
    BpiSearchOptions["ApplicantAgent"] = "Applicant Agent";
    BpiSearchOptions["ApplicantInfo"] = "Applicant Information";
    BpiSearchOptions["AppID"] = "Application ID";
    BpiSearchOptions["ApplicationStatus"] = "Application Status";
    BpiSearchOptions["ApplicationCategory"] = "Application Category";
    BpiSearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    BpiSearchOptions["AssignedToUsers"] = "Assigned to";
    BpiSearchOptions["UnassignedApplications"] = "Unassigned Applications";
    BpiSearchOptions["CreatedDate"] = "Created Date";
    BpiSearchOptions["CreatedDateRange"] = "Created Date Range";
    BpiSearchOptions["StartDate"] = "Started Date";
    BpiSearchOptions["StartDateRange"] = "Started Date Range";
    BpiSearchOptions["DaysUntilExpired"] = "Days until Expired";
    BpiSearchOptions["OwnerInfo"] = "Owner Information";
    BpiSearchOptions["PercentageComplete"] = "Percentage Complete";
    BpiSearchOptions["PropertyInfo"] = "Property Information";
    BpiSearchOptions["TimeoutStatus"] = "Timeout Status";
    BpiSearchOptions["BuildingUse"] = "Building Use";
    BpiSearchOptions["JobID"] = "Job ID";
})(BpiSearchOptions || (BpiSearchOptions = {}));
// TODO these columns will change depending on how columns have been configured. This is the default list
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["ErfNumber"] = "Erf Number";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["Sector"] = "Sector";
    ApplicationHeadingEnum["IsRDP"] = "Is RDP";
    ApplicationHeadingEnum["BuildingUse"] = "Building Use";
    ApplicationHeadingEnum["StartDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.ErfNumber, "erfNumbers"],
    [ApplicationHeadingEnum.ApplicationType, "applicationType"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.StartDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
// TODO: remove commented out sections?
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["FarmNumber"] = "Farm Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Phase";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.ErfNumber, "erfNumbers"],
    [ApplicationSummaryColumnsEnum.FarmNumber, "farmNumbers"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "applicationType"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const BpiSearchQueryLookup = new Map([
    [BpiSearchOptions.AppID, "appId"],
    [BpiSearchOptions.ReferenceNumber, "referenceNumber"],
    [BpiSearchOptions.JobID, "jobId"]
]);
export const BpiAdditionalSearchOptions = [BpiSearchOptions.MyApplications, BpiSearchOptions.AssignedToUsers, BpiSearchOptions.UnassignedApplications, BpiSearchOptions.ApplicationsWithoutStartDate];
export const BpiDateSearchOptions = new Map([[BpiSearchOptions.StartDate, 1], [BpiSearchOptions.StartDateRange, 2],]);
export const BpiStartDateRangeSearchOptions = new Map([[BpiSearchOptions.CreatedDate, 1], [BpiSearchOptions.CreatedDateRange, 2],]);
export const BpiStatusSearchOptions = new Map([[BpiSearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS], [BpiSearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE], [BpiSearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
    [BpiSearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS]
]);
export const BpiBuildingUseSearchOptions = new Map([
    [BpiSearchOptions.BuildingUse, ApplicationSearchConstants.BUILDING_USE],
]);
export const BpiSearchOptionClientHeight = new Map([[BpiSearchOptions.ReferenceNumber, SearchContainerHeight.Simple], [BpiSearchOptions.MyApplications, SearchContainerHeight.Simple], [BpiSearchOptions.AppID, SearchContainerHeight.Simple], [BpiSearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine], [BpiSearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine], [BpiSearchOptions.PercentageComplete, SearchContainerHeight.SingleLine], [BpiSearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine], [BpiSearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine], [BpiSearchOptions.CreatedDate, SearchContainerHeight.SingleLine], [BpiSearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine], [BpiSearchOptions.ApplicantAgent, SearchContainerHeight.Extended], [BpiSearchOptions.ApplicantInfo, SearchContainerHeight.Extended], [BpiSearchOptions.OwnerInfo, SearchContainerHeight.Extended], [BpiSearchOptions.PropertyInfo, SearchContainerHeight.Max]]);
// IMPORTANT: these values much match the DB table names and the Property names used by oData entity for TownPlanning
export var BpiSearchOptionTableListEnum;
(function (BpiSearchOptionTableListEnum) {
    BpiSearchOptionTableListEnum["Application"] = "BP_APPLICATION|Application";
    BpiSearchOptionTableListEnum["Property"] = "BP_APPLICATIONPROPERTY|Properties";
    BpiSearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
    BpiSearchOptionTableListEnum["Applicant"] = "AFLA_Recipient|Applicant";
    BpiSearchOptionTableListEnum["ApplicantAgent"] = "AFLA_Recipient|ApplicantAgent";
    BpiSearchOptionTableListEnum["Owner"] = "AFLA_Recipient|Owners";
})(BpiSearchOptionTableListEnum || (BpiSearchOptionTableListEnum = {}));
export const BPIExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_BPI;
export const BPITableNameListForSearchOptions = BpiSearchOptionTableListEnum.Application + "," + BpiSearchOptionTableListEnum.Property + "," + BpiSearchOptionTableListEnum.Status + "," + BpiSearchOptionTableListEnum.Applicant + "," + BpiSearchOptionTableListEnum.ApplicantAgent + "," + BpiSearchOptionTableListEnum.Owner;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["ApplicantAgent"] = "Applicant / agent";
    CreateApplicationMenuHeadings["Location"] = "Location";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant / applicant agent";
    ViewApplicationMenuHeadings["Location"] = "Location";
    ViewApplicationMenuHeadings["BpamsApplications"] = "Building plan applications";
    ViewApplicationMenuHeadings["Assessment"] = "Assessment";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    ViewApplicationMenuHeadings["Checklist"] = "Checklist";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Conditions"] = "Conditions";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["Invoices"] = "Invoices";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["RelatedApplicationSearch"] = "Related applications";
    ViewApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    ViewApplicationMenuHeadings["Result"] = "Result";
    ViewApplicationMenuHeadings["ScheduledReminders"] = "Scheduled Reminders";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Survey123"] = "Survey123";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    SettingsMenuHeadings["AFLAPortalDocuments"] = "Afla portal documents";
    SettingsMenuHeadings["AFLAPortalUpdateOwners"] = "Afla portal update owners";
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["SearchSettings"] = "Search settings";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    SettingsMenuHeadings["AFLAPortalMessagesAndPages"] = "AFLA portal messages and pages";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
export const BpiRequiredMapFields = [{
        mapName: "Property",
        fields: [
            { name: "OBJECTID", type: EsriDataTypeEnum.oid },
            { name: "SgCode", type: EsriDataTypeEnum.string },
            { name: "ErfNo", type: EsriDataTypeEnum.string },
            { name: "FarmNo", type: EsriDataTypeEnum.string },
            { name: "PtnNum", type: EsriDataTypeEnum.string },
            { name: "Allotment", type: EsriDataTypeEnum.string },
            { name: "PropertyDescription", type: EsriDataTypeEnum.string },
            { name: "Address", type: EsriDataTypeEnum.string },
            { name: "HasGeometry", type: EsriDataTypeEnum.integer },
            { name: "ErfSize", type: EsriDataTypeEnum.integer },
            { name: "TitleDeed", type: EsriDataTypeEnum.string },
            { name: "SectionalTitleSchemeID", type: EsriDataTypeEnum.string },
            { name: "Type", type: EsriDataTypeEnum.string },
            { name: "LegalStatus", type: EsriDataTypeEnum.string },
            { name: "FloorNo", type: EsriDataTypeEnum.string },
            { name: "FloorName", type: EsriDataTypeEnum.string },
            { name: "SgDiagramNo", type: EsriDataTypeEnum.string },
            { name: "UnitNumber", type: EsriDataTypeEnum.integer },
            { name: "Registered", type: EsriDataTypeEnum.smallInteger },
            { name: "SgCodeExternal", type: EsriDataTypeEnum.string },
            { name: "PremiseID", type: EsriDataTypeEnum.string },
            { name: "AccountNo", type: EsriDataTypeEnum.string },
            { name: "ZoningCategory", type: EsriDataTypeEnum.string },
            { name: "Shape", type: EsriDataTypeEnum.geometry },
            { name: "Shape_Area", type: EsriDataTypeEnum.double },
            { name: "Shape_Length", type: EsriDataTypeEnum.double }
        ]
    }];
let BpiStrategyService = class BpiStrategyService extends AflaModuleStrategyService {
    static { BpiStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    http;
    appController;
    router;
    recipientSelectService;
    overdueApplicationExpandFields = "status, applicant";
    showApplicantAgentForModule = true;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {};
    viewApplicationComponentLookup;
    name = ModuleConfig.BuildingPlansInspectorate;
    modulePrefix = ModulePrefix.BuildingPlansInspectorate;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    buildingUseSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable;
    applicationServiceUrl = ApiBuildingPlansInspectorateConstants.URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = BPIExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = BPIExpandListForApplicationSearch;
    searchOptionTableNameList = BPITableNameListForSearchOptions;
    customApplicationTableColumnMap;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Welcome page",
        "Property help",
        "Application help",
        "Agent help",
        "Required documentation help",
        "Notes help",
        "Applicant help",
        "Summary help",
        "Create application status page",
        "View application status page",
        "Communication help"
    ];
    setApplicantAndApplicantAgentAction = ApiBuildingPlansInspectorateConstants.FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT;
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "Properties";
    moduleRequiredMaps;
    // stampOptions = [{ name: "Building plan number", expand: "", attribute: "buildingPlanNumber" }];
    stampOptions = [];
    previousApplication = null;
    postApplicationSubscription;
    statusColumn = "status/ workflowSection";
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, requestStatusService, http, appController, router, recipientSelectService) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.recipientSelectService = recipientSelectService;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.BUILDING_PLANS_INSPECTORATE_ENDPOINT;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Properties"];
        this.requiredMapFields = BpiRequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}') and eLodgementComplete eq true`;
    }
    static buildExpand(params, top) {
        params = params.set(ODataAction.Expand, BPIExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate ne null desc, startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    buildListFilter(list, column) {
        const params = BpiStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = BpiSearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = BpiAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(BpiSearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(BpiSearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = BpiDateSearchOptions;
        this.RangeSearchOptions = BpiStartDateRangeSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = BpiStatusSearchOptions;
        this.clientHeightMap = BpiSearchOptionClientHeight;
    }
    initializeBuildingUseSearchOptions() {
        this.buildingUseSearchOptions = BpiBuildingUseSearchOptions;
        this.clientHeightMap = BpiSearchOptionClientHeight;
    }
    initializeGroupSearchOptions = () => {
    };
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: BpiStrategyService_1.buildModuleIDFilter(moduleId),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-ignore
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) { // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            erfNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "erfNumber"),
            farmNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "farmNumber"),
            applicationType: application.applicationType,
            applicant: BpiStrategyService_1.getRecipientName(BpiStrategyService_1.getFirstRecipient(application.applicant)),
            agent: BpiStrategyService_1.getRecipientName(BpiStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "applicant":
                                case "applicantagent":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = groupValue;
                                        break;
                                    }
                                    break;
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                                case "properties":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                    }
                                    break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        // 3rd level tables
        const propertyDetails = [ApplicationSearchConstants.OWNERS, ApplicationSearchConstants.PROPERTY_BUILDINGS, ApplicationSearchConstants.PROPERTY_ZONINGS];
        if (!fieldValue && propertyDetails.indexOf(appGroup.toLowerCase()) > -1) {
            if (application.properties.length > 0) {
                application.properties.forEach((property) => {
                    for (const [propkey, propVal] of Object.entries(property)) {
                        if (propkey.toLowerCase() === appGroup.toLowerCase() || (propkey.toLowerCase().endsWith(ApplicationSearchConstants.ZONINGS) && appGroup.toLowerCase().endsWith(ApplicationSearchConstants.ZONINGS)) || (propkey.toLowerCase().endsWith(ApplicationSearchConstants.BUILDINGS) && appGroup.toLowerCase().endsWith(ApplicationSearchConstants.BUILDINGS))) {
                            propVal.forEach((value) => {
                                for (const [groupKey, groupValue] of Object.entries(value)) {
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                    }
                                }
                            });
                        }
                    }
                });
            }
        }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") || fieldName.toLowerCase().startsWith("date")) {
            fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createdby":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.createdBy) : "";
                    break;
                case "assignedto":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.assignedTo) : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 && columnList.length !== this.customApplicationTableColumnMap.size) || isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                const fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(BpiSearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        if (application) {
            return this.defaultSearchModel(application);
        }
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [ViewApplicationMenuHeadings.Details, ViewApplicationDetailsBpiComponent],
            [ViewApplicationMenuHeadings.Location, ViewApplicationLocationBpiComponent],
            [ViewApplicationMenuHeadings.BpamsApplications, ViewApplicationBpamsApplicationsBpiComponent]
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [CreateApplicationMenuHeadings.Details, CreateApplicationDetailsBpiComponent],
            [CreateApplicationMenuHeadings.Location, CreateApplicationLocationBpiComponent]
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
            [BpiSearchOptions.ApplicantAgent, SearchApplicantAgentComponent],
            [BpiSearchOptions.AssignedToUsers, SearchAssignedToComponent],
            [BpiSearchOptions.BuildingUse, SearchBuildingUseComponent],
            [BpiSearchOptions.CreatedDate, SearchCreatedDateComponent],
            [BpiSearchOptions.CreatedDateRange, SearchCreatedDateComponent],
            [BpiSearchOptions.StartDate, SearchStartDateComponent],
            [BpiSearchOptions.StartDateRange, SearchStartDateComponent],
            [BpiSearchOptions.ApplicantInfo, SearchApplicantInfoComponent],
            [BpiSearchOptions.PercentageComplete, SearchStatusComponent],
            [BpiSearchOptions.ApplicationStatus, SearchStatusComponent],
            [BpiSearchOptions.ApplicationCategory, SearchCategoryComponent],
            [BpiSearchOptions.TimeoutStatus, SearchStatusComponent],
            [BpiSearchOptions.DaysUntilExpired, SearchStatusComponent],
            [BpiSearchOptions.OwnerInfo, SearchOwnerInfoComponent],
            [BpiSearchOptions.PropertyInfo, SearchPropertyInfoBpiComponent]
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap ? this.customApplicationTableColumnMap : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationsQuery(params) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID, useCompleteListForSearch) {
        let params = BpiStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), BpiStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = BpiStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, BpiStrategyService_1.buildModuleIDFilter(moduleID), BpiStrategyService_1.showCompleteApplications());
        return this.getApplicationsQuery(params);
    }
    buildDashboardApplicationsSearch(moduleID, dashboardFilter) {
        let params = BpiStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.applicationSearchService.dashboardSearch(params, dashboardFilter, moduleID);
        return this.getApplicationsQuery(params);
    }
    createApplication() {
        this.requestStatusService.showBusySpinner("CreateBPIApplication");
        const application = this.buildApplication();
        this.postApplicationSubscription = this.postApplicationService(application).subscribe({
            next: (savedApplication) => {
                this.appController.showMessage(BpiStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                this.resetForm();
                this.requestStatusService.removeBusySpinner("CreateBPIApplication");
                this.router.navigate([
                    AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                    {
                        jobId: savedApplication.jobId,
                        moduleId: this.appController.selectedModuleID,
                        type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                    }
                ]);
            }, error: (error) => {
                this.requestStatusService.removeBusySpinner("CreateBPIApplication");
                this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
            }
        });
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "shape, properties",
            $expand: "properties",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    resetForm() {
        this.form.reset();
        this.form.get("propertiesForm").get("properties").clear();
        this.form.get("noteForm").get("notes").clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiBuildingPlansInspectorateConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, properties($expand=owners), lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_BP_APPLICATIONS_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_BP_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID, canDownloadInPortal = false) {
        const params = {
            invoiceId: invoiceID,
            canDownloadInPortal
        };
        return this.http.get(`${ApiBuildingPlansInspectorateConstants.URL}/${applicationId}/${ApiBuildingPlansInspectorateConstants.FUNCTION_GET_GENERATE_INVOICE}`, {
            responseType: "blob",
            params
        });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId
        };
        return this.http.get(`${ApiBuildingPlansInspectorateConstants.URL}/${applicationId}/${ApiBuildingPlansInspectorateConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        const params = {
            jobId,
            category
        };
        return this.http.get(`${ApiBuildingPlansInspectorateConstants.URL}/${moduleId}/${ApiBuildingPlansInspectorateConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    initForm() {
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                copyApplicantDetails: new FormControl(null),
                markApplicantAgentAsNotApplicable: new FormControl(null)
            }),
            noteForm: new FormGroup({
                newNote: new FormControl(null), notes: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                applicationType: new FormControl(null, [Validators.required]),
                hasBpamsReferenceNumber: new FormControl(null, [Validators.required]),
                bpamsReferenceNumber: new FormControl(null, [Validators.required]),
                bpamsApplicationId: new FormControl(null, [Validators.required]),
                isVerified: new FormControl(null, [Validators.required]),
                referenceNumber: new FormControl(null)
            }),
            propertiesForm: new FormGroup({
                properties: new FormArray([], [Validators.minLength(1), Validators.required]),
            })
        });
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.OpenApplications:
                return SharedConstants.DASHBOARD_FILTERS.OpenApplications;
            case SharedConstants.DASHBOARD_FILTERS.ClosedApplications:
                return SharedConstants.DASHBOARD_FILTERS.ClosedApplications;
            case SharedConstants.DASHBOARD_FILTERS.TotalApplications:
                return SharedConstants.DASHBOARD_FILTERS.TotalApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    buildApplication() {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeRecipientProperties(applicantFormValue);
        const copyApplicantDetails = this.form.get("applicantForm").get("copyApplicantDetails").value;
        const markApplicantAgentAsNotApplicable = this.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").value;
        let applicantAgent = null;
        const applicantAgentRecipientFormControl = this.form.get("applicantForm").get("applicantAgentRecipient");
        if (copyApplicantDetails) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, applicantAgentRecipientFormControl, true);
        }
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            const applicantAgentFormValue = this.form
                .get("applicantForm")
                .get("applicantAgentRecipient").value;
            applicantAgent = RecipientUtils.removeRecipientProperties(applicantAgentFormValue);
        }
        const application = {
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            applicationType: this.form.get("detailsForm").get("applicationType").value,
            bpamsReferenceNumber: this.form.get("detailsForm").get("bpamsReferenceNumber").value,
            bpamsApplicationId: this.form.get("detailsForm").get("bpamsApplicationId").value,
            shape: "",
            wkid: 102100,
            applicant: [applicant],
            applicantAgent: [],
            notes: [],
            properties: [],
            applicantAgentNa: !markApplicantAgentAsNotApplicable,
        };
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            application.applicantAgent.push(applicantAgent);
        }
        const notesArray = this.form.get("noteForm").get("notes");
        notesArray.controls.forEach((item) => {
            const note = {
                note: item.get("note").value,
            };
            application.notes.push(note);
        });
        const points = [];
        const propertiesArray = this.form
            .get("propertiesForm")
            .get("properties");
        propertiesArray.controls.forEach((item) => {
            const centroid = item.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            const owners = item.get("owners").value.recipients;
            owners.forEach((owner) => {
                RecipientUtils.removeRecipientProperties(owner);
            });
            const property = {
                address: item.get("address").value,
                allotment: item.get("allotment").value,
                erfNumber: item.get("erfNo").value,
                erfSize: parseFloat(item.get("erfSize").value),
                farmNumber: item.get("farmNo").value,
                sgCode: item.get("sgCode").value,
                shape: geometryJSON,
                subdivision: item.get("subdivision").value,
                titleDeed: item.get("titleDeed").value,
                wkid: 102100,
                owners,
            };
            application.properties.push(property);
        });
        const shape = `MULTIPOINT (${points.join(", ")})`;
        application.shape = shape;
        return application;
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        return undefined;
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiBuildingPlansInspectorateConstants.URL}/${jobId}/${ApiBuildingPlansInspectorateConstants.FUNCTION_APPLICATION_TYPES}`;
        return this.http.get(url, { params });
    }
    saveDraftApplication() {
    }
    getDraftApplication() {
        return null;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router },
        { type: RecipientSelectService }
    ];
};
BpiStrategyService = BpiStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsub()
], BpiStrategyService);
export { BpiStrategyService };
